import type { ComponentStyleConfig } from "@chakra-ui/react";

export const TextTheme: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "body",
  },
  variants: {
    quote: {
      fontFamily: "Northwell",
      fontSize: 36,
      py: 8,
    },
  },
};
